import type { MessageDescriptor } from "@airange/shared/i18n-exam-admin";
import { formatMessage as sharedFormatMessage } from "@airange/shared/i18n-exam-admin";

export type FormatMessageFn = (descriptor: MessageDescriptor) => string;

export const defaultFormatMessage: FormatMessageFn = (descriptor) =>
  sharedFormatMessage(descriptor);

export function normalizeStringValue(value?: string | null) {
  return String(value ?? "").trim();
}

export function formatKnownLabel(
  normalizedValue: string,
  labelKeyMap: Record<string, string>,
  formatMessage: FormatMessageFn,
  emptyFallbackId = "common.labels.empty",
) {
  const labelKey = labelKeyMap[normalizedValue];
  if (labelKey) {
    return formatMessage({ id: labelKey });
  }
  if (normalizedValue) {
    return normalizedValue;
  }
  return formatMessage({ id: emptyFallbackId });
}
